import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { WorkItemService } from './work-item.service'
import { WorkItem } from './work-item'
import { catchError, EMPTY, Observable } from 'rxjs'
import { ElderToastService } from '@elderbyte/ngx-starter'

export const workItemResolver: ResolveFn<Observable<WorkItem>> = (route, state) => {
  const workItemService = inject(WorkItemService)
  const toastService = inject(ElderToastService)
  const id = route.paramMap.get('itemId')
  return workItemService.findById(id).pipe(
    catchError((err) => {
      toastService.error('messages.loading_failed', err)
      return EMPTY
    })
  )
}
